import QuoteForm from "util/QuoteForm";
import RecaptchaHelper from "RecaptchaHelper";
import AjaxForm, {EVENT_SUCCESS} from "webPage/AjaxForm";

export default class Quote {
    constructor($element) {
        this.$element = $element;
        this.$productInformation = this.$element.find('.js-part[data-part="items"]');
        this.$itemsOverview = this.$element.find('.js-items-overview');
        this.bindEvents();
    }

    bindEvents() {
        this.productForm = new QuoteForm(this.$productInformation, this.getInitialValues());
        this.productForm.on('submit', (data) => {
            this.$itemsOverview.html('');
            this.$itemsOverview.append(this.buildQuoteItem(data));
            this.showAdditionalDetails();
        });

        this.$element.on('click', '.js-back', () => {
            this.showItems();
        });

        RecaptchaHelper.load().then(() => {
            RecaptchaHelper.init(this.$element);

            this.quoteForm = new AjaxForm(this.$element.find('.js-quote-form'), async ($form, formData) => {
                formData.items = this.productForm.getData();
                formData.additional_details = 'undefined' !== typeof formData.items.additional_details ? formData.items.additional_details : null;
                formData.files = 'undefined' !== typeof formData.items.files ? formData.items.files : null;

                //Setting this to an array to mimic the old functionality of being able to have multiple
                formData.items = [formData.items];

                const response = await RecaptchaHelper.validate().then((captcha) => {
                    formData.captcha = captcha;
                    return Ajax.post('leamington-blinds', 'get-a-quote', formData);
                });

                if (response.status !== 'success') {
                    throw response;
                }
                return response;
            });

            this.quoteForm.on(EVENT_SUCCESS, (data) => {
                let token = data['quote'].token;
                if ('undefined' === typeof token) {
                    console.warn('Invalid token value returned', data);
                }
                let url = '/get-a-quote/?result=' + token;

                try {
                    dataLayer.push({
                        'event': 'quote-submit', 'eventCallback': function () {
                            window.location.href = url;
                        }
                    });
                } catch (e) {
                    console.log(e);
                    window.location.href = url;
                }
            });
        });
    }

    showItems() {
        this.$element.find('.js-part').hide();
        this.$element.find('.js-part[data-part="items"]').show();
    }

    showAdditionalDetails() {
        this.$element.find('.js-part').hide();
        this.$element.find('.js-part[data-part="additional-details"]').show();
    }

    getInitialValues() {
        let initialValues = {};

        if (this.$element.find('.js-initial-values').length > 0) {
            try {
                initialValues = JSON.parse(this.$element.find('.js-initial-values').text());
                if (initialValues.length <= 0) {
                    initialValues = {};
                }
            } catch (e) {
                console.warn('Could not load initial values', e);
            }
        }
        return initialValues;
    }

    formatItemData(data) {
        data = $.extend(data, {}, {
            name: '', sub: [],
        });

        if (['blinds', 'shutters'].indexOf(data['product-type']) !== -1) {
            data.name = this.formatString('undefined' !== typeof data['product-select'] ? data['product-select'] : '');
        } else {
            data.name = this.formatString('undefined' !== typeof data['product-type'] ? data['product-type'] : '');
        }

        if (['blinds', 'shutters'].indexOf(data['product-type']) !== -1) {
            if ('undefined' !== typeof data['window-type']) {
                data.sub.push(this.formatString(data['window-type']))
            }

            if ('undefined' !== typeof data['features[]']) {
                if (!Array.isArray(data['features[]'])) {
                    data.sub.push(this.formatString(data['features[]']));
                } else if (data['features[]'].length > 0) {
                    data['features[]'].forEach((feature) => {
                        data.sub.push(this.formatString(feature));
                    });
                }
            }

            if ('undefined' !== typeof data['fit-type']) {
                data.sub.push(this.formatString(data['fit-type']))
            }
        } else if (['pergolas'].indexOf(data['product-type']) !== -1) {
            if ('undefined' !== typeof data['pergola-type']) {
                data.sub.push(this.formatString(data['pergola-type']))
            }
        }

        return data;
    }

    formatString(string) {
        if (string === 'undecided') {
            return "Don't Know";
        }

        string = string.charAt(0).toUpperCase() + string.slice(1);
        string = string.replace('-', ' ');
        return string;
    }

    buildQuoteItem(data) {
        data = this.formatItemData(data);
        let $measurements = [];

        if (['blinds', 'shutters'].indexOf(data['product-type']) !== -1) {
            if (data['has-measurements'] === 'no') {
                $measurements.push(eotwJSXFactory('p', {className: "quote-product__value-measurement"}, ["No measurements provided"]));
            } else {
                data.measurements.forEach((measurement, index) => {
                    $measurements.push(eotwJSXFactory('p', {className: "quote-product__value-measurement"}, [eotwJSXFactory('strong', null, ["Window ", index + 1, " - "]),"W", measurement.width + measurement.unit, " x D", measurement.drop + measurement.unit]));
                });
            }
        }

        return (eotwJSXFactory('div', {className: "form-grid-sidebar-layout__section form-grid-sidebar-layout__section--no-border js-item"}, [
            eotwJSXFactory('div', {className: "form-grid-sidebar-layout__content form-grid-sidebar-layout__content--quote-product-wrap"}, [
                eotwJSXFactory('div', {className: "quote-product js-item"}, [
                    eotwJSXFactory('div', {className: "quote-product__text"}, [
                        eotwJSXFactory('h3', {className: "quote-product__heading"}, [data.name]),
                        eotwJSXFactory('p', null, [data.sub.join(', ')])
                    ]),
                    (['blinds', 'shutters'].indexOf(data['product-type']) !== -1) ? (eotwJSXFactory('div', {className: "quote-product__values"}, [
                        eotwJSXFactory('p', {className: "quote-product__value-title"}, ["Measurements"]),
                        $measurements
                    ])) : ''
                ])
            ])
        ]));
    }
}
